import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 530.9 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 530.9 512\" id=\"close\"><style>#close .st0{fill-rule:evenodd;clip-rule:evenodd}</style><path class=\"st0\" d=\"M530.9 20.2L510.1 0 265.5 237.3 20.7 0 0 20.1l244.8 237.3L3.1 491.8 23.9 512l241.7-234.4 239.6 232.2 20.7-20.1-239.6-232.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/close.svg
// module id = 292
// module chunks = 6